import i18n from '@/i18n';
import ProductPage from '@/pages/ProductPage/ProductPage.vue';
import { createPinia } from 'pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate';
import 'vite/modulepreload-polyfill';
import { createApp } from 'vue';
import VueLazyload from 'vue3-lazyload';

createApp(ProductPage)
  .use(i18n)
  .use(VueLazyload, {})
  .use(createPinia().use(createPersistedState({ storage: localStorage })))
  .mount('#configurator-app');
